























































































import _ from "lodash";

import store from "@/store";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Auth from "@aws-amplify/auth";

import { Maintenancejob, User } from "@/models";
import { MaintenancejobsState } from "@/store/maintenancejobs/types";

@Component
export default class Navbar extends Vue {
  @State("maintenancejobs") public maintenancejobsState: MaintenancejobsState;

  @Prop() private placeholder!: string;

  @Getter("auth/email") public email: string;
  @Getter("auth/isAdministrator") public isAdministrator: boolean;
  @Getter("auth/isSysAdmin") public isSysAdmin: boolean;
  @Getter("auth/signedIn") public signedIn: boolean;
  @Getter("auth/isCustomer") public isCustomer: boolean;
  @Getter("auth/isSupport") public isSupport: boolean;
  @Getter("maintenancejobs/current") public job: Maintenancejob;

  @Mutation("auth/setCognitoUser")
  public setCognitoUser: (user: any) => void;

  @Action("maintenancejobs/resetCurrentPage")
  public resetCurrentPage: () => Promise<any>;

  /**
   * @see https://aws-amplify.github.io/docs/js/authentication
   */
  public async signOut() {
    try {
      this.$router.push({ name: "home" });
      // Check if there are any unsaved changes before signing the user out.
      if (
        !store.getters["customers/hasUnsavedChanges"] &&
        !store.getters["maintenancejobs/hasUnsavedChanges"]
      ) {
        await Auth.signOut();
        this.setCognitoUser(null);
        this.$router.push({ name: "sign-in" });
      }
    } catch (err) {
      this.$onecentral.displayError(err);
    }
  }

  /**
   * The Maintenancejobs URL is appended with the month or search from Vuex.
   */
  public getJobsUrl() {
    let url = "/maintenancejobs";

    if (this.maintenancejobsState.month) {
      url += `?month=${encodeURI(this.maintenancejobsState.month)}`;
    } else if (this.maintenancejobsState.search) {
      url += `?search=${encodeURI(this.maintenancejobsState.search)}`;
    }

    return url;
  }

  public toggleSidebar(event: any) {
    event.preventDefault();
    this.$emit("togglesidebar", event);
  }
  public redirectPage() {
    if (this.signedIn) {
      this.$router.push({ name: "maintenancejobs" });
    }
  }
  public isHidePart() {
    if (
      (this.$route.name === "feedback" ||
        this.$route.name === "notification") &&
      !this.signedIn
    ) {
      return true;
    }
    return false;
  }
}
